import React from 'react';
import uniqueId from 'lodash/uniqueId';
var LiteratureCoverLetter = function (props) {
    var title = props.deviation.title;
    var filteredTitle = title && title.replace(/[^a-zA-Z]/g, '');
    if (!filteredTitle || !filteredTitle.length) {
        return null;
    }
    var gradientId = "lit-gradient" + uniqueId();
    return (React.createElement("div", { className: "daeditor-literature-letter" },
        React.createElement("svg", { height: "100%", viewBox: "0 0 15 12", preserveAspectRatio: "xMidYMin slice", fillRule: "evenodd" },
            React.createElement("linearGradient", { x1: "100%", y1: "16.1729237%", x2: "100%", y2: "83.3711592%", id: gradientId },
                React.createElement("stop", { stopColor: "#00FF77", offset: "0%" }),
                React.createElement("stop", { stopColor: "#3197EF", stopOpacity: "0", offset: "100%" })),
            React.createElement("text", { className: "daeditor-literature-letter-inner", fill: "url(#" + gradientId + ")", x: "15", y: "-9%", textAnchor: "end", alignmentBaseline: "hanging" }, filteredTitle[0]))));
};
LiteratureCoverLetter.displayName = 'LiteratureCoverLetter';
export default LiteratureCoverLetter;
//# sourceMappingURL=HtmlLiteratureCoverLetter.js.map